import { MetricLead } from './metricLead';

export class MetricLeadResponse {

  metricLead: MetricLead;

  constructor(metricLead: MetricLead) {
    this.metricLead = metricLead;
  }

  getMetricLead(): MetricLead {
    const metricLeadObject = new MetricLead();
    metricLeadObject.createdAt = this.metricLead.createdAt;
    metricLeadObject.updatedAt = this.metricLead.updatedAt;
    metricLeadObject.firstAssignedDate = this.metricLead.firstAssignedDate;
    metricLeadObject.firstUserAssigned = this.metricLead.firstUserAssigned;
    metricLeadObject.firstInteractionDate = this.metricLead.firstInteractionDate;
    metricLeadObject.realResponseTime = this.metricLead.realResponseTime;
    metricLeadObject.firstContactBussinessSeconds = this.metricLead.firstContactBussinessSeconds;
    metricLeadObject.firstContactDate = this.metricLead.firstContactDate;
    metricLeadObject.endDefeatDate = this.metricLead.endDefeatDate;
    metricLeadObject.onTrack = this.metricLead.onTrack;
    metricLeadObject.transferred = this.metricLead.transferred;
    metricLeadObject.assignedDate = this.metricLead.assignedDate;
    metricLeadObject.firstCallDate = this.metricLead.firstCallDate;
    metricLeadObject.callStartTime = this.metricLead.callStartTime;
    metricLeadObject.inCall = this.metricLead.inCall;
    metricLeadObject.timesTransferred = this.metricLead.timesTransferred;
    metricLeadObject.timesEdited = this.metricLead.timesEdited;
    metricLeadObject.timesWithoutCallResponse = this.metricLead.timesWithoutCallResponse;
    metricLeadObject.durationWithoutCallResponse = this.metricLead.durationWithoutCallResponse;
    metricLeadObject.timesWithCallResponse = this.metricLead.timesWithCallResponse;
    metricLeadObject.durationWithCallResponse = this.metricLead.durationWithCallResponse;
    metricLeadObject.whatsappsSent = this.metricLead.whatsappsSent;
    metricLeadObject.emailsSent = this.metricLead.emailsSent;
    metricLeadObject.emailsReceived = this.metricLead.emailsReceived;
    metricLeadObject.remindersScheduled = this.metricLead.remindersScheduled;
    metricLeadObject.visitScheduled = this.metricLead.visitScheduled;
    metricLeadObject.totalInteractions = this.metricLead.totalInteractions;
    metricLeadObject.firstContactUserName = this.metricLead.firstContactUserName;

    return metricLeadObject;
  }
}
